var initError = false;
var sumitting = false;
var interval =  2000;
function reset () {
	setTimeout(function () {
		sumitting = false;
		interval += 2000;
	}, window.enhancerErrorInterval || interval);
}
function getCookie (name) {
  var cookieStr;
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    cookieStr = cookies[i].split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
      return decodeURI(cookieStr[1]);
    }
  }
}
var oldError = window.onerror;

try {
	var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
	var month = 30 * 24 * 3600 * 1000;
	Object.keys(errorData).forEach(function (key) {
		var item = errorData[key];
		if (Date.now() - item.time > month) {
			delete errorData[key];
		}
	});
	localStorage.setItem('errorData', JSON.stringify(errorData));
} catch (err) {
	console.error(err);
}

function checkLow () {
	var agent = navigator.userAgent.toLowerCase();
	var ie = /(msie\s|trident.*rv:)([\w.]+)/i.test(agent)

	if(ie) {
		var v1 = agent.match(/(?:msie\s([\w.]+))/);
		var v2 = agent.match(/(?:trident.*rv:([\w.]+))/);
		var version;
		if (v1 && v2 && v1[1] && v2[1]) {
		  version = Math.max(v1[1] * 1, v2[1] * 1);
		} else if (v1 && v1[1]) {
		  version = v1[1] * 1;
		} else if (v2 && v2[1]) {
		  version = v2[1] * 1;
		} else {
		  version = 0;
		}
		return version < 11;
	} else {
		 return false;
	}
}

module.exports = function (projectName, url, cb) {
	if (initError) {
		return;
	}
	initError = true;
	window.onerror = checkLow() ? function () {} : function (msg, uri, row, col, err) {
		if (msg.toLowerCase() === 'script error.' && !uri) {
			return
		}
		uri = uri || ( document.currentScript && document.currentScript.src) || '';
		col = typeof col === 'number' ? col : 0;
		var stack = err ? err.stack : '';
		var key = msg + location.host + row + col;
		uri = uri || ('+' + window.location.href);

		try {
			var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
			if (errorData[key] && errorData[key].stack === stack.toString()) {
				return;
			}
		} catch (err) {
			console.error(err);
		}

		try {
			if (sumitting) {
				return;
			}
			sumitting = true;
			
			var submitData = {
				project: projectName,
				msg: msg,
				uri: uri,
				row: row,
				uid: getCookie('uid') || '',
				col: col,
				ua: window.navigator.userAgent,
				stack: stack
			};
			$.ajax({
				url: url || '/tool/error',
				type: 'POST',
				data: submitData
			}).done(function (res) {
				reset();
				try {
					var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
					errorData[key] = {
						time: Date.now(),
						stack: stack.toString()
					};
					localStorage.setItem('errorData', JSON.stringify(errorData))
				} catch (err) {
					console.error(err);
				}
			}).fail(function () {
				reset();
				console.log(arguments);
			});

			if (oldError) {
				oldError.call(window, msg, uri, row, col, err);
			}
			cb && cb(submitData);
		} catch (err) {
			console.log(err);
			reset();
		}
	}

	window.addEventListener('error', function(e) {
		var error = e.error;
		if (error) {
			var msg = error.message || e.message || '';
			if (msg.toLowerCase() === 'script error.' && !e.filename && !error.filename) {
				return
			}
			window.onerror(msg, e.filename, e.lineno, e.colno, error);
		} else {
			var stack = e.target.outerHTML || e.message;
			if (stack.indexOf('hm.baidu.com') === -1) {
				if (!e.message && e.target.outerHTML) {
					stack += ' ---- ';
    			var node = e.target.parentNode;
    			while (node && node.tagName) {
			      stack += '-> ' + node.tagName + '(' + (node.className || node.id || node.src || node.href || '')  + ')';
			      node = node.parentNode;
			    }
				}
				if (e.filename) {
					window.onerror(e.message || 'network error', e.filename, e.lineno || -1, e.colno || -1, { stack: stack });
				}
			}
		}
	}, true);
}


//////////////////
// WEBPACK FOOTER
// ./~/@enhancer/fe-error-track/index.js
// module id = 7
// module chunks = 0